import React, { useEffect, useState } from 'react'
import { Alert } from '@material-tailwind/react'

export default function AlertPopup({ display, icon, color, title, description }) {
  const [open, setOpen] = useState(display || false)

  useEffect(() => {
    setOpen(display);
  }, [display])

  return (
    <div className='absolute top-20 lg:w-1/3 h-14'>
      <Alert open={open} icon={icon || undefined} color={color || "gray"} onClose={() => setOpen(false)}>
        <div className='flex flex-col'>
          <span className='font-medium'>{title}</span>
          <span>{description}</span>
        </div>
      </Alert>
    </div>
  )
}
